import { assertDefined } from '../../../../cross-team-shared/misc-utils/strict-record';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { planeSize } from '../../../render/mesh/subpoint-measurement/measurement-plane-helper';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { CloudShaderMaterial } from '../cloud-shader-material';

export const subpointMeasurementModeUniforms = `
  struct SubpointMeasurementModeUniforms {
    vec3 measureTarget;
  };
`;

export const getColorForSubpointMeasurementMode = `
  bool shouldHighlightPoint() {
    vec3 measureTarget = color.subpointMeasurement.measureTarget;

    const float areaSize = float(${planeSize}) / 2.;
    vec2 areaMaxPoint = measureTarget.xy + areaSize;
    vec2 areaMinPoint = measureTarget.xy - areaSize;

    bool isInArea = all( lessThanEqual( position.xy, areaMaxPoint ) ) &&
    all( greaterThanEqual( position.xy, areaMinPoint ) );

    const float tolerance = 0.01;
    float zDistance = abs( position.z - measureTarget.z );
    return isInArea && zDistance <= tolerance;
  }

  vec4 getColorForSubpointMeasurementMode() {
    if(shouldHighlightPoint()){
      return vec4(1.0, 0.0, 0.0, 1.0);
    } else {
      return  vec4(0.478, 0.478, 0.478, 1.0);
    }
  }
`;

export interface SubpointMeasurementModeUniforms {
  measureTarget: Point3D;
}

export function setSubpointMeasurementModeUniforms(
  material: CloudShaderMaterial,
  state?: PointCloudContentState,
) {
  let measureTarget: Point3D;

  if (state) {
    const measurement = state.render.subpointHeightMeasurement!;
    assertDefined(measurement);
    const { reference, target } = measurement;
    measureTarget = [reference[0], reference[1], target[2]];
  } else {
    measureTarget = [0, 0, 0];
  }

  material.setColorUniform('subpointMeasurement', { measureTarget });
}
